import React from "react";
import { useOutletContext } from "react-router-dom";

export default function CustomerPortalProfile() {
  const { customer } = useOutletContext();

  return (
    <div className="w-full p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">My Profile</h1>
        <p className="text-sm text-gray-500 mt-1">Your account details on file with McCallum Bros.</p>
      </div>

      <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100">
          <h2 className="text-base font-semibold text-gray-900">Account Details</h2>
        </div>
        <div className="p-5 grid grid-cols-1 gap-5 md:grid-cols-2">
          <Field label="Company Name" value={customer.companyName} />
          <Field label="Contact Name" value={customer.contactName} />
          <Field label="Email" value={customer.email} />
          <Field label="Phone" value={customer.phone} />
          <Field label="Customer Type" value={customer.customerType} capitalize />
          <Field
            label="Address"
            value={[customer.address?.line1, customer.address?.city, customer.address?.region]
              .filter(Boolean)
              .join(", ") || "—"}
          />
        </div>
      </div>

      <div className="rounded-xl border border-blue-200 bg-blue-50 px-5 py-4 text-sm text-blue-800">
        Need to update any of these details? Contact McCallum Bros directly — (09) 828 5202.
      </div>
    </div>
  );
}

function Field({ label, value, capitalize }) {
  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1">{label}</div>
      <div className={`text-sm font-medium text-gray-900 ${capitalize ? "capitalize" : ""}`}>{value || "—"}</div>
    </div>
  );
}
